<form
  #form="ngForm"
  (ngSubmit)="onSubmit(form)">
  @if (vermieterModalProperties.isModal) {
    <div nxModalContent>
      <ng-container [ngTemplateOutlet]="Content"> </ng-container>
    </div>
  }
  @if (!vermieterModalProperties.isModal) {
    <div>
      <ng-container [ngTemplateOutlet]="Content"> </ng-container>
    </div>
  }
  <ng-template #Content>
    <h3
      [ngClass]="vermieterModalProperties.isModal ? 'text-30' : 'text-24'"
      class="h3 semibold">
      {{ "vermieter.header.title" | text }}
      <info-icon
        [ariaLabel]="'vermieter.header.title' | simpleText"
        textKey="vermieter.header.info"></info-icon>
    </h3>

    @for (vermietetesObjekt of vermieteteObjekte; track trackByFn(i); let i = $index) {
      <nx-card class="nx-margin-bottom-2xs nx-margin-top-xs">
        <nxt-fieldset
          appearance="default"
          class="formfield-margin-bottom">
          <nxt-fieldset-title>
            <span>{{ "vermieter.grundstueckBebaut.title" | text }}</span>
            <info-icon
              [ariaLabel]="'vermieter.grundstueckBebaut.title' | simpleText"
              textKey="vermieter.grundstueckBebaut.info"
              class="nx-margin-right-5xl"></info-icon>
            <span class="remove">
              @if (shouldShowEntfernenLink()) {
                <nx-link
                  (click)="deleteVermietetesObjekt(i)"
                  (keyup.enter)="deleteVermietetesObjekt(i)"
                  [attr.data-cy]="'rs-delete-vermietetes-objekt-' + i"
                  [attr.aria-label]="'vermieter.entfernenLabel' | simpleText"
                  [id]="'deleteVermietetesObjekt_' + i"
                  class="vm-schutz-delete-link"
                  tabindex="0">
                  <a>
                    <nx-icon name="{{ 'vermieter.entfernenIcon' | text }}"></nx-icon>
                    {{ "vermieter.entfernenLabel" | text }}
                  </a>
                </nx-link>
              }
            </span>
          </nxt-fieldset-title>
          <div nxtFieldsetContent>
            <nx-radio-group
              #bebautesGrundstueck="ngModel"
              (groupValueChange)="grundstueckBebautChanged(i, $event.value)"
              [name]="'bebautesGrundstueck' + i"
              [ngModel]="vermietetesObjekt.grundstueckBebaut"
              [disabled]="vermietetesObjekt.vorbelegt"
              required>
              <div class="flex-row">
                <nx-radio
                  [attr.data-cy]="'rs-vermietetes-objekt-bebaut-radio-ja-' + i"
                  [id]="'bebautesGrundstueck-true-' + i"
                  [value]="vermietetesObjektBebautEnum.BEBAUT"
                  class="nx-margin-right-m">
                  <div
                    [attr.aria-label]="
                      createAriaLabelForObjektWithIndexAndDescriptionAndError(
                        shouldShowBebauetesGruendstueckRequiredError(bebautesGrundstueck, form),
                        'vermieter.grundstueckBebaut.title' | text,
                        'vermieter.grundstueckBebaut.bebaut' | text,
                        i + 1,
                        'vermieter.grundstueckBebaut.required' | text
                      )
                    ">
                    {{ "vermieter.grundstueckBebaut.bebaut" | text }}
                  </div>
                </nx-radio>
                <nx-radio
                  [attr.data-cy]="'rs-vermietetes-objekt-bebaut-radio-nein-' + i"
                  [id]="'bebautesGrundstueck-false-' + i"
                  [value]="vermietetesObjektBebautEnum.UNBEBAUT">
                  <div
                    [attr.aria-label]="
                      createAriaLabelForObjektWithIndexAndDescriptionAndError(
                        shouldShowBebauetesGruendstueckRequiredError(bebautesGrundstueck, form),
                        'vermieter.grundstueckBebaut.title' | text,
                        'vermieter.grundstueckBebaut.unbebaut' | text,
                        i + 1,
                        'vermieter.grundstueckBebaut.required' | text
                      )
                    ">
                    {{ "vermieter.grundstueckBebaut.unbebaut" | text }}
                  </div>
                </nx-radio>
              </div>
              @if (shouldShowBebauetesGruendstueckRequiredError(bebautesGrundstueck, form)) {
                <nx-error
                  appearance="text"
                  class="nx-margin-bottom-0"
                  nxFormfieldError>
                  <span [innerHTML]="'vermieter.grundstueckBebaut.required' | html"></span>
                </nx-error>
              }
            </nx-radio-group>
          </div>
        </nxt-fieldset>
        <nxt-fieldset appearance="default">
          <nxt-fieldset-title class="first-fieldset-title">
            <span>
              <span>{{ "vermieter.adresse.label" | text }}</span>
            </span>
          </nxt-fieldset-title>
          <div nxtFieldsetContent>
            <div>
              @if (isAzamUnderwriter$ | async) {
                <div>
                  <ps20-frontend-auslaendische-adresse-checkbox
                    id="auslaendischeAdresseCheckbox"
                    (auslaendischeAdresseCheckboxEvent)="
                      auslaendischeAdressChecboxChanged(i, $event, vermietetesObjekt.grundstueckBebaut)
                    "
                    [isChecked]="vermietetesObjekt.auslaendischeAdresse"
                    [alignContentToTheLeft]="true"
                    [text]="getAuslaendischeAdresseText()"
                    data-cy="rs-auslaendische-adresse">
                  </ps20-frontend-auslaendische-adresse-checkbox>
                </div>
              }
            </div>
            <div nxRow>
              <div nxCol="4">
                <nx-formfield label="{{ 'vermieter.adresse.plz.label' | simpleText }}">
                  <input
                    #postleitzahl="ngModel"
                    (ngModelChange)="plzChanged(i, $event, postleitzahl)"
                    [attr.data-cy]="'rs-vermieter-plz-input-' + i"
                    [name]="'postleitzahl_' + i"
                    [attr.aria-label]="
                      createAriaLabelForObjektWithIndex('vermieter.adresse.plz.label' | simpleText, i + 1)
                    "
                    [ngModel]="vermietetesObjekt.plz"
                    [disabled]="
                      vermietetesObjekt.vorbelegt ||
                      ((isAzamUnderwriter$ | async) && vermietetesObjekt.auslaendischeAdresse)
                    "
                    [nxAriaLabel]="createAriaLabelForObjektWithIndex('vermieter.adresse.plz.label' | simpleText, i + 1)"
                    autocomplete="off"
                    nxInput
                    nxMask="00000"
                    pattern="{{ 'MELDEBEHOERDE_PLZ' | regexpAsString }}"
                    required />
                  <nx-error
                    appearance="text"
                    class="nx-margin-bottom-0"
                    nxFormfieldError>
                    @if (postleitzahl?.errors?.pattern) {
                      <span
                        [attr.data-cy]="'rs-vermieter-plz-input-' + i + '-pattern-error'"
                        [innerHTML]="'vermieter.adresse.plz.pattern' | html"></span>
                    }
                    @if (postleitzahl?.errors?.required) {
                      <span
                        [attr.data-cy]="'rs-vermieter-plz-input-' + i + '-required-error'"
                        [innerHTML]="'vermieter.adresse.plz.required' | html"></span>
                    }
                  </nx-error>
                </nx-formfield>
                @if (shouldShowPlzPatternError(vermietetesObjekt, postleitzahl)) {
                  <nx-error
                    appearance="text"
                    class="nx-margin-bottom-0 negative-margin-s"
                    nxFormfieldError>
                    <span
                      [attr.data-cy]="'rs-vermieter-plz-input-' + i + '-pattern-error'"
                      [innerHTML]="'vermieter.adresse.plz.invalid' | html"></span>
                  </nx-error>
                }
              </div>
              <div nxCol="8">
                <ps20-frontend-adress-input-component
                  (auswahlChanged)="ortChanged(i, $event)"
                  [aktuelleAuswahl]="vermietetesObjekt.ort"
                  [auswahlListe]="vermietetesObjekt.orte"
                  [name]="'rs-vermieter-ort-' + i"
                  [texte]="
                    addAriaLabelToAdressInputComponent(orteTexte, 'vermieter.adresse.ort.label' | simpleText, i + 1)
                  "
                  [texte]="orteTexte"
                  [disabled]="
                    vermietetesObjekt.vorbelegt ||
                    ((isAzamUnderwriter$ | async) && vermietetesObjekt.auslaendischeAdresse)
                  ">
                </ps20-frontend-adress-input-component>
              </div>
            </div>
            <div nxRow>
              <div nxCol="6">
                <ps20-frontend-adress-input-component
                  (auswahlChanged)="strasseChanged(i, $event)"
                  [aktuelleAuswahl]="vermietetesObjekt.strasse"
                  [auswahlListe]="
                    addKeineAuswahlOption(vermietetesObjekt.strassen, vermietetesObjekt.grundstueckBebaut)
                  "
                  [name]="'rs-vermieter-strasse-' + i"
                  [texte]="
                    addAriaLabelToAdressInputComponent(
                      strassenTexte,
                      'vermieter.adresse.strasse.label' | simpleText,
                      i + 1
                    )
                  "
                  [texte]="strassenTexte"
                  [disabled]="
                    vermietetesObjekt.vorbelegt ||
                    ((isAzamUnderwriter$ | async) && vermietetesObjekt.auslaendischeAdresse)
                  ">
                </ps20-frontend-adress-input-component>
              </div>
              @if (vermietetesObjekt.grundstueckBebaut !== 2) {
                <div nxCol="6">
                  <nx-formfield label="{{ 'vermieter.adresse.hausnummer.label' | text }}">
                    <input
                      #hausnummer="ngModel"
                      (ngModelChange)="hausnummerChanged(i, $event)"
                      [attr.data-cy]="'rs-vermieter-hausnummer-input-' + i"
                      [name]="'hausnummer_' + i"
                      [attr.aria-label]="
                        createAriaLabelForObjektWithIndex('vermieter.adresse.hausnummer.label' | simpleText, i + 1)
                      "
                      [ngModel]="vermietetesObjekt.hausnummer"
                      [disabled]="
                        vermietetesObjekt.vorbelegt ||
                        ((isAzamUnderwriter$ | async) && vermietetesObjekt.auslaendischeAdresse)
                      "
                      [nxAriaLabel]="
                        createAriaLabelForObjektWithIndex('vermieter.adresse.hausnummer.label' | simpleText, i + 1)
                      "
                      autocomplete="off"
                      nxInput
                      pattern="{{ 'HAUSNUMMERZUSATZ' | regexpAsString }}"
                      required />
                    <nx-error
                      appearance="text"
                      class="nx-margin-bottom-0"
                      nxFormfieldError>
                      @if (hausnummer?.errors?.pattern) {
                        <span
                          [attr.data-cy]="'rs-vermieter-hausnummer-input-' + i + '-pattern-error'"
                          [innerHTML]="'vermieter.adresse.hausnummer.pattern' | html"></span>
                      }
                      @if (hausnummer?.errors?.required) {
                        <span
                          [attr.data-cy]="'rs-vermieter-hausnummer-input-' + i + '-required-error'"
                          [innerHTML]="'vermieter.adresse.hausnummer.required' | html"></span>
                      }
                    </nx-error>
                  </nx-formfield>
                </div>
              }
            </div>
            @if (vermietetesObjekt.grundstueckBebaut === 2) {
              <div nxRow>
                <div nxCol="6">
                  <nx-formfield label="{{ 'vermieter.flurstueck.label' | text }}">
                    <input
                      #flurstuecknummer="ngModel"
                      (ngModelChange)="flurstuecknummerChanged(i, $event)"
                      [attr.data-cy]="'rs-vermieter-flurstuecknummer-input-' + i"
                      [name]="'flurstuecknummer_' + i"
                      [attr.aria-label]="
                        createAriaLabelForObjektWithIndex('vermieter.flurstueck.label' | simpleText, i + 1)
                      "
                      [ngModel]="vermietetesObjekt.flurstueckNummer"
                      [disabled]="(isAzamUnderwriter$ | async) && vermietetesObjekt.auslaendischeAdresse"
                      [placeholder]="'vermieter.flurstueck.placeholder' | simpleText"
                      [nxAriaLabel]="
                        createAriaLabelForObjektWithIndex('vermieter.flurstueck.label' | simpleText, i + 1)
                      "
                      autocomplete="off"
                      nxInput
                      pattern="{{ 'FLURSTUECKNUMMER' | regexpAsString }}"
                      required />
                    <nx-error
                      appearance="text"
                      class="nx-margin-bottom-0"
                      nxFormfieldError>
                      @if (flurstuecknummer?.errors?.pattern) {
                        <span
                          [attr.data-cy]="'rs-vermieter-flurstuecknummer-input-' + i + '-pattern-error'"
                          [innerHTML]="'vermieter.flurstueck.pattern' | html"></span>
                      }
                      @if (flurstuecknummer?.errors?.required) {
                        <span
                          [attr.data-cy]="'rs-vermieter-flurstuecknummer-input-' + i + '-required-error'"
                          [innerHTML]="'vermieter.flurstueck.required' | html"></span>
                      }
                    </nx-error>
                  </nx-formfield>
                </div>
                <div
                  nxCol="1"
                  class="flurstueck-info-icon">
                  <info-icon
                    class="flurstueck-info-icon-margin-top"
                    [ariaLabel]="'vermieter.flurstueck.label' | simpleText"
                    textKey="vermieter.flurstueck.info"></info-icon>
                </div>
              </div>
            }
          </div>
        </nxt-fieldset>
        <div>
          @switch (vermietetesObjekt.grundstueckBebaut) {
            @case (vermietetesObjektBebautEnum.BEBAUT) {
              <div class="nx-margin-top-4m">
                <nxt-fieldset appearance="default">
                  <nxt-fieldset-title>
                    <span>{{ "vermieter.grundstueckBebaut.wohneinheit.title" | text }}</span>
                    <info-icon
                      [ariaLabel]="'vermieter.grundstueckBebaut.wohneinheit.title' | simpleText"
                      textKey="vermieter.grundstueckBebaut.wohneinheit.info"></info-icon>
                  </nxt-fieldset-title>
                  <div
                    class="nx-margin-bottom-2m"
                    nxtFieldsetContent>
                    <div
                      class="flex-align-start"
                      nxRow>
                      <div
                        [nxCol]="vermieterModalProperties.isModal ? '4' : '3'"
                        class="nx-margin-bottom-m">
                        <nx-number-stepper
                          class="nx-margin-top-2m nx-stepper ng-valid ng-touched ng-dirty"
                          #wohneinheitenStepper="ngModel"
                          (valueChange)="anzahlWohneinheitChanged(i, $event, wohneinheitenStepper)"
                          [attr.data-cy]="'rs-vermietetes-objekt-anzahl-wohneinheiten-stepper-' + i"
                          [name]="'anzahl-wohneinheiten-stepper-' + i"
                          [ngModel]="vermietetesObjekt.wohneinheiten"
                          [max]="vermieterModalProperties.maxStepperValue"
                          [inputAriaLabel]="
                            createAriaLabelForObjektWithIndex(
                              'vermieter.grundstueckBebaut.wohneinheit.title' | simpleText,
                              i + 1
                            )
                          "
                          [incrementAriaLabel]="
                            createAriaLabelForObjektWithIndexAndDescription(
                              'vermieter.grundstueckBebaut.wohneinheit.anzahl' | screenreader,
                              'vermieter.incrementButton' | screenreader,
                              i + 1
                            )
                          "
                          [decrementAriaLabel]="
                            createAriaLabelForObjektWithIndexAndDescription(
                              'vermieter.grundstueckBebaut.wohneinheit.anzahl' | screenreader,
                              'vermieter.decrementButton' | screenreader,
                              i + 1
                            )
                          "
                          leadingZero="false"
                          [ngClass]="{ 'has-error': !isBebauteGrundstueckeGesetzt(vermietetesObjekt) }">
                        </nx-number-stepper>
                      </div>
                      <div
                        class="form-field-info-icon top-aligned"
                        nxCol="7">
                        <nx-formfield label="{{ 'vermieter.grundstueckBebaut.wohneinheit.hint' | text }}">
                          <input
                            #bruttojahresmieteWohneinheit="ngModel"
                            (ngModelChange)="bruttojahresmieteWohneinheitChanged(i, $event)"
                            (paste)="jahresmietePaste($event)"
                            [attr.data-cy]="'rs-vermietetes-objekt-anzahl-wohneinheiten-textfield-' + i"
                            [disabled]="vermietetesObjekt.wohneinheiten === 0"
                            [name]="'bruttojahresmieteWohneinheit_' + i"
                            [attr.aria-label]="
                              createAriaLabelForObjektWithIndex(
                                ('vermieter.grundstueckBebaut.wohneinheit.hint' | text) +
                                  ' ' +
                                  ('vermieter.grundstueckBebaut.wohneinheit.title' | text),
                                i + 1
                              )
                            "
                            [ngModel]="vermietetesObjekt.bruttojahresmieteWohneinheiten"
                            [nxAriaLabel]="
                              createAriaLabelForObjektWithIndex(
                                ('vermieter.grundstueckBebaut.wohneinheit.hint' | text) +
                                  ' ' +
                                  ('vermieter.grundstueckBebaut.wohneinheit.title' | text),
                                i + 1
                              )
                            "
                            currencyMask
                            autocomplete="off"
                            nxInput
                            [minNumericValue]="1"
                            [maxNumericValue]="1500000"
                            required />
                          <nx-error
                            appearance="text"
                            class="nx-margin-bottom-0"
                            nxFormfieldError>
                            @if (bruttojahresmieteWohneinheit?.errors?.required) {
                              <span
                                [attr.data-cy]="
                                  'rs-vermietetes-objekt-anzahl-wohneinheiten-textfield-' + i + '-required-error'
                                "
                                [innerHTML]="'vermieter.grundstueckBebaut.wohneinheit.required' | html"></span>
                            }
                            @if (
                              bruttojahresmieteWohneinheit?.errors?.max || bruttojahresmieteWohneinheit?.errors?.min
                            ) {
                              <span
                                [attr.data-cy]="
                                  'rs-vermietetes-objekt-anzahl-wohneinheiten-textfield-' + i + '-pattern-error'
                                "
                                [innerHTML]="'vermieter.grundstueckBebaut.wohneinheit.pattern' | html"></span>
                            }
                          </nx-error>
                        </nx-formfield>
                        <info-icon
                          class="vermieter-grundstueckBebaut-icon"
                          [ariaLabel]="('vermieter.grundstueckBebaut.wohneinheit.title' | simpleText) + ' ' + ('vermieter.grundstueckBebaut.wohneinheit.hint' | simpleText)"
                          textKey="vermieter.grundstueckBebaut.bruttoJahresmieteInfo"></info-icon>
                      </div>
                      @if (
                        shouldShowStepperError(vermietetesObjekt.wohneinheiten) &&
                        vermieterModalProperties.showStepperHint
                      ) {
                        <ps20-frontend-hinweis
                          class="hinweis-width"
                          [content]="'vermieter.grundstueckBebaut.wohneinheit.limit' | text"
                          [alignToLeft]="true">
                        </ps20-frontend-hinweis>
                      }
                    </div>
                  </div>
                </nxt-fieldset>
                <nxt-fieldset appearance="default">
                  <nxt-fieldset-title>
                    <span>{{ "vermieter.grundstueckBebaut.gewerbeeinheit.title" | text }}</span>
                    <info-icon
                      [ariaLabel]="'vermieter.grundstueckBebaut.gewerbeeinheit.title' | simpleText"
                      textKey="vermieter.grundstueckBebaut.gewerbeeinheit.info"></info-icon>
                  </nxt-fieldset-title>
                  <div
                    class="nx-margin-bottom-2m"
                    nxtFieldsetContent>
                    <div
                      class="flex-align-start"
                      nxRow>
                      <div
                        [nxCol]="vermieterModalProperties.isModal ? '4' : '3'"
                        [ngClass]="
                          vermieterModalProperties.isModal ? 'nx-margin-bottom-m nx-margin-top-2m' : 'nx-margin-top-2m'
                        ">
                        <nx-number-stepper
                          #gewerbeeinheitStepper="ngModel"
                          (valueChange)="anzahlGewerbeeinheitenChanged(i, $event, gewerbeeinheitStepper)"
                          [attr.data-cy]="'rs-vermietetes-objekt-anzahl-gewerbeeinheiten-stepper-' + i"
                          [name]="'anzahl-gewerbeeinheit-stepper-' + i"
                          [ngModel]="vermietetesObjekt.gewerbeeinheiten"
                          [max]="vermieterModalProperties.maxStepperValue"
                          [inputAriaLabel]="
                            createAriaLabelForObjektWithIndex(
                              'vermieter.grundstueckBebaut.gewerbeeinheit.title' | simpleText,
                              i + 1
                            )
                          "
                          [incrementAriaLabel]="
                            createAriaLabelForObjektWithIndexAndDescription(
                              'vermieter.grundstueckBebaut.gewerbeeinheit.anzahl' | screenreader,
                              'vermieter.incrementButton' | screenreader,
                              i + 1
                            )
                          "
                          [decrementAriaLabel]="
                            createAriaLabelForObjektWithIndexAndDescription(
                              'vermieter.grundstueckBebaut.gewerbeeinheit.anzahl' | screenreader,
                              'vermieter.decrementButton' | screenreader,
                              i + 1
                            )
                          "
                          leadingZero="false">
                        </nx-number-stepper>
                      </div>
                      <div
                        class="form-field-info-icon top-aligned"
                        nxCol="7">
                        <nx-formfield label="{{ 'vermieter.grundstueckBebaut.gewerbeeinheit.hint' | text }}">
                          <input
                            #bruttojahresmieteGewerbeeinheiten="ngModel"
                            (ngModelChange)="bruttojahresmieteGewerbeeinheitenChanged(i, $event)"
                            (keypress)="jahresmieteKeyPress($event)"
                            (paste)="jahresmietePaste($event)"
                            [attr.data-cy]="'rs-vermietetes-objekt-anzahl-gewerbeeinheiten-textfield-' + i"
                            [disabled]="vermietetesObjekt.gewerbeeinheiten === 0"
                            [name]="'bruttojahresmieteGewerbeeinheiten' + i"
                            [attr.aria-label]="
                              createAriaLabelForObjektWithIndex(
                                ('vermieter.grundstueckBebaut.gewerbeeinheit.hint' | text) +
                                  ' ' +
                                  ('vermieter.grundstueckBebaut.gewerbeeinheit.title' | text),
                                i + 1
                              )
                            "
                            [ngModel]="vermietetesObjekt.bruttojahresmieteGewerbeeinheiten"
                            [nxAriaLabel]="
                              createAriaLabelForObjektWithIndex(
                                ('vermieter.grundstueckBebaut.gewerbeeinheit.hint' | text) +
                                  ' ' +
                                  ('vermieter.grundstueckBebaut.gewerbeeinheit.title' | text),
                                i + 1
                              )
                            "
                            currencyMask
                            autocomplete="off"
                            nxInput
                            [minNumericValue]="1"
                            [maxNumericValue]="1500000"
                            required />
                          <nx-error
                            appearance="text"
                            class="nx-margin-bottom-0"
                            nxFormfieldError>
                            @if (bruttojahresmieteGewerbeeinheiten?.errors?.required) {
                              <span
                                [attr.data-cy]="
                                  'rs-vermietetes-objekt-anzahl-gewerbeeinheiten-textfield-' + i + '-required-error'
                                "
                                [innerHTML]="'vermieter.grundstueckBebaut.gewerbeeinheit.required' | html"></span>
                            }
                            @if (
                              bruttojahresmieteGewerbeeinheiten?.errors?.max ||
                              bruttojahresmieteGewerbeeinheiten?.errors?.min
                            ) {
                              <span
                                [attr.data-cy]="
                                  'rs-vermietetes-objekt-anzahl-gewerbeeinheiten-textfield-' + i + '-pattern-error'
                                "
                                [innerHTML]="'vermieter.grundstueckBebaut.gewerbeeinheit.pattern' | html"></span>
                            }
                          </nx-error>
                        </nx-formfield>
                        <info-icon
                          class="vermieter-grundstueckBebaut-icon"
                          [ariaLabel]="('vermieter.grundstueckBebaut.gewerbeeinheit.title' | simpleText) + ' ' + ('vermieter.grundstueckBebaut.gewerbeeinheit.hint' | simpleText)"
                          textKey="vermieter.grundstueckBebaut.bruttoJahresmieteInfo"></info-icon>
                      </div>
                      @if (
                        shouldShowStepperError(vermietetesObjekt.gewerbeeinheiten) &&
                        vermieterModalProperties.showStepperHint
                      ) {
                        <ps20-frontend-hinweis
                          class="hinweis-width"
                          [content]="'vermieter.grundstueckBebaut.gewerbeeinheit.limit' | text"
                          [alignToLeft]="true">
                        </ps20-frontend-hinweis>
                      }
                    </div>
                  </div>
                </nxt-fieldset>
                <nxt-fieldset appearance="default">
                  <nxt-fieldset-title>
                    <span>{{ "vermieter.grundstueckBebaut.stellplatz.title" | text }}</span>
                    <info-icon
                      [ariaLabel]="'vermieter.grundstueckBebaut.stellplatz.title' | simpleText"
                      textKey="vermieter.grundstueckBebaut.stellplatz.info"></info-icon>
                  </nxt-fieldset-title>
                  <div nxtFieldsetContent>
                    <div
                      class="flex-align-start"
                      nxRow>
                      <div
                        [nxCol]="vermieterModalProperties.isModal ? '4' : '3'"
                        class="nx-margin-bottom-m nx-margin-top-2m">
                        <nx-number-stepper
                          #stellplaetzeStepper="ngModel"
                          (valueChange)="anzahlStellplaetzeChanged(i, $event, stellplaetzeStepper)"
                          [attr.data-cy]="'rs-vermietetes-objekt-anzahl-stellplaetze-stepper-' + i"
                          [name]="'anzahl-stellplaetze-stepper-' + i"
                          [ngModel]="vermietetesObjekt.stellplaetze"
                          [max]="vermieterModalProperties.maxStepperValue"
                          [inputAriaLabel]="
                            createAriaLabelForObjektWithIndex(
                              'vermieter.grundstueckBebaut.stellplatz.title' | simpleText,
                              i + 1
                            )
                          "
                          [incrementAriaLabel]="
                            createAriaLabelForObjektWithIndexAndDescription(
                              'vermieter.grundstueckBebaut.stellplatz.anzahl' | screenreader,
                              'vermieter.incrementButton' | screenreader,
                              i + 1
                            )
                          "
                          [decrementAriaLabel]="
                            createAriaLabelForObjektWithIndexAndDescription(
                              'vermieter.grundstueckBebaut.stellplatz.anzahl' | screenreader,
                              'vermieter.decrementButton' | screenreader,
                              i + 1
                            )
                          "
                          leadingZero="false">
                        </nx-number-stepper>
                      </div>
                      <div
                        class="form-field-info-icon top-aligned"
                        nxCol="7">
                        <nx-formfield label="{{ 'vermieter.grundstueckBebaut.stellplatz.hint' | text }}">
                          <input
                            #bruttojahresmieteStellplaetze="ngModel"
                            (ngModelChange)="bruttojahresmieteStellplaetzeChanged(i, $event)"
                            (keypress)="jahresmieteKeyPress($event)"
                            (paste)="jahresmietePaste($event)"
                            [attr.data-cy]="'rs-vermietetes-objekt-anzahl-stellplaetze-textfield-' + i"
                            [disabled]="vermietetesObjekt.stellplaetze === 0"
                            [name]="'bruttojahresmieteStellplaetze' + i"
                            [attr.aria-label]="
                              createAriaLabelForObjektWithIndex(
                                ('vermieter.grundstueckBebaut.stellplatz.hint' | text) +
                                  ' ' +
                                  ('vermieter.grundstueckBebaut.stellplatz.title' | text),
                                i + 1
                              )
                            "
                            [ngModel]="vermietetesObjekt.bruttojahresmieteStellplaetze"
                            [nxAriaLabel]="
                              createAriaLabelForObjektWithIndex(
                                ('vermieter.grundstueckBebaut.stellplatz.hint' | text) +
                                  ' ' +
                                  ('vermieter.grundstueckBebaut.stellplatz.title' | text),
                                i + 1
                              )
                            "
                            autocomplete="off"
                            nxInput
                            [minNumericValue]="1"
                            [maxNumericValue]="1500000"
                            currencyMask
                            required />
                          <nx-error
                            appearance="text"
                            class="nx-margin-bottom-0"
                            nxFormfieldError>
                            @if (bruttojahresmieteStellplaetze?.errors?.required) {
                              <span
                                [attr.data-cy]="
                                  'rs-vermietetes-objekt-anzahl-stellplaetze-textfield-' + i + '-required-error'
                                "
                                [innerHTML]="'vermieter.grundstueckBebaut.stellplatz.required' | html"></span>
                            }
                            @if (
                              bruttojahresmieteStellplaetze?.errors?.max || bruttojahresmieteStellplaetze?.errors?.min
                            ) {
                              <span
                                [attr.data-cy]="
                                  'rs-vermietetes-objekt-anzahl-stellplaetze-textfield-' + i + '-pattern-error'
                                "
                                [innerHTML]="'vermieter.grundstueckBebaut.stellplatz.pattern' | html"></span>
                            }
                          </nx-error>
                        </nx-formfield>
                        <info-icon
                          class="vermieter-grundstueckBebaut-icon"
                          [ariaLabel]="('vermieter.grundstueckBebaut.stellplatz.title' | simpleText) + ' ' + ('vermieter.grundstueckBebaut.stellplatz.hint' | simpleText)"
                          textKey="vermieter.grundstueckBebaut.bruttoJahresmieteInfo"></info-icon>
                      </div>
                      @if (
                        shouldShowStepperError(vermietetesObjekt.stellplaetze) &&
                        vermieterModalProperties.showStepperHint
                      ) {
                        <ps20-frontend-hinweis
                          class="hinweis-width"
                          [content]="'vermieter.grundstueckBebaut.stellplatz.limit' | text"
                          [alignToLeft]="true">
                        </ps20-frontend-hinweis>
                      }
                    </div>
                  </div>
                </nxt-fieldset>
                @if (
                  shouldShowObiektAnzahlRequiredError(
                    vermietetesObjekt,
                    wohneinheitenStepper,
                    gewerbeeinheitStepper,
                    stellplaetzeStepper,
                    form
                  )
                ) {
                  <nx-message
                    appearance="text"
                    class="has-error nx-margin-bottom-0 nx-margin-top-0"
                    nxFormfieldError
                    context="error"
                    [attr.data-cy]="'rs-vermietetes-objekt-anzahl-' + i + '-required-error'">
                    {{ "vermieter.grundstueckBebaut.vermietetesObjektRequired" | text }}
                  </nx-message>
                }
              </div>
            }
            @case (vermietetesObjektBebautEnum.UNBEBAUT) {
              <div class="nx-margin-top-xs">
                <nxt-fieldset appearance="default">
                  <nxt-fieldset-title class="first-fieldset-title">
                    <span>{{ "vermieter.grundstueckBebaut.grundstueckflaeche.title" | text }}</span>
                  </nxt-fieldset-title>
                  <div nxtFieldsetContent>
                    <div nxRow>
                      <div nxCol="6">
                        <nx-formfield label="{{ 'vermieter.grundstueckBebaut.grundstueckflaeche.hint' | text }}">
                          <input
                            #grundstueckFlaeche="ngModel"
                            (ngModelChange)="grundstueckFlaecheChanged(i, $event)"
                            [attr.data-cy]="'rs-vermieter-grundstueckflaeche-input-' + i"
                            [name]="'grundstueckFlaeche' + i"
                            [attr.aria-label]="
                              createAriaLabelForObjektWithIndex(
                                'vermieter.grundstueckBebaut.grundstueckflaeche.hint' | simpleText,
                                i + 1
                              )
                            "
                            [ngModel]="vermietetesObjekt.grundstueckFlaeche"
                            [nxAriaLabel]="
                              createAriaLabelForObjektWithIndex(
                                'vermieter.grundstueckBebaut.grundstueckflaeche.hint' | simpleText,
                                i + 1
                              )
                            "
                            autocomplete="off"
                            nxInput
                            pattern="{{ 'GRUNDSTUECKFLAECHE' | regexpAsString }}"
                            required
                            type="number" />
                          <span nxFormfieldSuffix>m²</span>
                          <nx-error
                            appearance="text"
                            class="nx-margin-bottom-0"
                            nxFormfieldError>
                            @if (grundstueckFlaeche?.errors?.pattern) {
                              <span
                                [attr.data-cy]="'rs-vermieter-grundstueckflaeche-input-' + i + '-pattern-error'"
                                [innerHTML]="'vermieter.grundstueckBebaut.grundstueckflaeche.pattern' | html"></span>
                            }
                            @if (grundstueckFlaeche?.errors?.required) {
                              <span
                                [attr.data-cy]="'rs-vermieter-grundstueckflaeche-input-' + i + '-required-error'"
                                [innerHTML]="'vermieter.grundstueckBebaut.grundstueckflaeche.required' | html"></span>
                            }
                          </nx-error>
                        </nx-formfield>
                      </div>
                    </div>
                  </div>
                </nxt-fieldset>
              </div>
            }
          }
        </div>
      </nx-card>
    }
    <div>
      @if (canAddVermietetesObjektItem()) {
        <nx-link
          (click)="addVermietetesObjekt()"
          (keyup.enter)="addVermietetesObjekt()"
          [class]="vermieterModalProperties.isModal ? 'nx-margin-bottom-4m' : ''"
          [attr.aria-label]="'vermieter.addLink' | simpleText"
          data-cy="vermietetes-objekt-hinzufuegen-link"
          nxStyle="block"
          tabindex="0">
          <a>
            <nx-icon name="plus"></nx-icon>
            {{ "vermieter.addLink" | text }}
          </a>
        </nx-link>
      }
    </div>
  </ng-template>
  @if (vermieterModalProperties.isModal) {
    <div nxModalActions>
      <button
        [disabled]="getSubmitButtonDisabled() || form.invalid"
        data-cy="rs-angebot-vermietete-objekte-uebernehmen-button"
        nxButton="primary small"
        class="nx-margin-bottom-0"
        type="submit">
        {{ "vermieter.submit" | text }}
      </button>
    </div>
  }
</form>
